// PLUGINS IMPORTS //
import React, { JSXElementConstructor, useState } from "react"
import { Link as ScrollLink } from "react-scroll"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import NavItem from "./NavItem/NavItem"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { GlobalStyles } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

export interface AboutNavigationItemType {
  title: string
  icon: string
  children?: JSXElementConstructor<any>
}

type PropsType = {
  navigatorItems: Array<AboutNavigationItemType>
}

const SideNavigator: React.FC<PropsType> = (props) => {
  const [selected, setSelected] = useState<string>(
    props.navigatorItems[0].title
  )

  return (
    <Wrapper>
      {props.navigatorItems.map((item) => (
        <ScrollLink
          to={item.title}
          smooth={true}
          offset={-30}
          duration={500}
          ignoreCancelEvents={true}
          spy={true}
          onSetActive={(link) => setSelected(link)}
        >
          <NavItem item={item} isSelected={selected === item.title} />
        </ScrollLink>
      ))}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  border-radius: 0px 20px;

  height: 100%;
  width: 50px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  overflow-x: hidden;
  margin-top: ${GlobalStyles.insets.pageTop}px;

  @media (max-width: 1330px) {
    display: none;
  }
`

export default React.memo(SideNavigator, memoComparison)
